module.exports = __webpack_public_path__ + "static/img/index1.209b4e1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index1.gif
// module id = fa1O
// module chunks = 0